// API para obtener los tipos de periodo
const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

// Obtener tipos de periodo - acepta institutionId como parámetro opcional
// Si no se pasa institutionId, obtiene TODOS los tipos de período activos
export async function getPeriodTypes(institutionId = null) {
  try {
    // Construir URL base
    let url = `${API_BASE}/catalogos/tipos-periodo-academico/`;
    
    // Solo filtrar por institución si se proporciona explícitamente
    // Para el selector de Ciclos Escolares, se necesitan TODOS los tipos de período
    if (institutionId) {
      url += `?id_institucion=${institutionId}`;
    }
    
    console.log('🔍 getPeriodTypes - Llamando endpoint:', url);
    const res = await fetch(url, {
      headers: getAuthHeaders()
    });
    
    if (!res.ok) throw new Error('Error al obtener tipos de periodo');
    
    const data = await res.json();
    console.log('📦 getPeriodTypes - Datos recibidos del backend:', data);
    console.log('📊 getPeriodTypes - Total de registros:', Array.isArray(data) ? data.length : 0);
    
    // Mapear todos los campos necesarios para el frontend
    const mapped = Array.isArray(data)
      ? data.map(tp => ({
          id: tp.id_tipo_periodo,
          nombre: tp.nombre_periodo,
          codigo: tp.codigo_periodo,
          periodosPorAnio: tp.periodos_por_anio,
          duracionSemanas: tp.duracion_semanas,
          descripcion: tp.descripcion,
          activo: tp.activo,
          idInstitucion: tp.id_institucion
        }))
      : [];
    
    console.log('✅ getPeriodTypes - Datos mapeados:', mapped);
    return mapped;
  } catch (e) {
    console.error('❌ Error en getPeriodTypes:', e);
    return [];
  }
}

